import i18n from '@/providers/i18n'
import VueFormGenerator from "vue-form-generator";

import _ from 'lodash';

var validators = {};

const error_message_replacements = {
  fieldIsRequired: 'validation:required',
  invalidFormat: 'validation:regex',
  numberTooSmall: 'validation:min.number',
  numberTooBig: 'validation:max.number',
  invalidNumber: 'validation:numeric',
  invalidInteger: 'validation:integer',
  textTooSmall: 'validation:min.string',
	textTooBig: 'validation:max.string',
	thisNotText: 'validation:string',

	thisNotArray: 'validation:array',

	selectMinItems: 'validation:min.array',
	selectMaxItems: 'validation:max.array',

	invalidDate: 'validation:date',
	dateIsEarly: 'validation:after',
	dateIsLate: 'validation:before',

	invalidEmail: 'validation:email',
	invalidURL: 'validation:url',

	invalidTextContainNumber: 'validation:alpha',
	invalidTextContainSpec: 'validation:alpha_num',
};

for (let [name, original_validator] of Object.entries(VueFormGenerator.validators)) {
  if (typeof original_validator === 'function') {
    validators[name] = function (val, field, state, custom_messages) {
        var error_messages = Object.assign({},
          custom_messages,
          VueFormGenerator.validators.resources,
          error_message_replacements,
        );
        var result = original_validator(val, field, state, error_messages);
        if (Array.isArray(result)) {
          return _.uniq(result.map(str => i18n.i18next.t(
            str, {
              attribute: (field.label || '') + ' ',
              min: field.min,
              max: field.max,
            }
          )));
        }
        return result;
      ;
    }
  }
}

export default validators;


// WEBPACK FOOTER //
// ./src/providers/validation/validators.js